import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StyledControlledInput } from './styles/StyledControlledInput';



class ControlledInput extends Component {
  
  createPlaceholder(name) {
    switch(name) {
      case "name":
        return "Jméno a Příjmení";
      case "phone":
        return "+420"
      case "email":
        return "email@email.cz"
    }
  }
  
  render() {
    const { value, handleChange, name,  inputState,  icon, placeHolder, required } = this.props; 

    return (
      <StyledControlledInput className="form-group has-feedback">
        <label htmlFor={'input_' + name} form="contact_form">
          {required && (<span className='requiredLabel'>* </span>)}
          {placeHolder}
        </label>
        <div className="controlled-input-container">
          <i className={"fa fa-" + icon + " controlled-input-icon controlled-input-icon-"  + inputState}></i>
          <input 
            id={'input_' + name}
            name={'input_' + name}
            type="text" 
            className={"form-control controlled-input-input controlled-input-" + inputState}
            placeholder={this.createPlaceholder(name)}
            required={required}
            aria-required={required}
            value={value} 
            onChange={e => handleChange(e.target.value, name)}
          />
        </div>


      </StyledControlledInput>
    );
  }
}


ControlledInput.propTypes = {
  inputState: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeHolder: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  required: PropTypes.bool.isRequired,
};


export default ControlledInput;
